export default __webpack_public_path__ + "static/media/file-word.b36fa116.svg";